/**
 * ALC-589 — PLP Aggregata: header tab navigation.
 * Progressive enhancement: highlights the tab whose target collection section
 * is in view (scroll-spy) and smooth-scrolls on click. No-op if a header has
 * no internal anchor tabs or their targets are missing.
 */
(function () {
  function initHeader(header) {
    // Tutti i tab-link (anche quelli senza anchor, es. il primo "Tutte le
    // discipline" attivo di default): la deselezione deve toccare TUTTI i
    // link, altrimenti il tab attivo server-side resta evidenziato per
    // sempre insieme a quello attivato dallo scroll-spy.
    var allLinks = Array.prototype.slice.call(
      header.querySelectorAll('.alc-plp-header__tab-link')
    );
    var links = Array.prototype.slice.call(
      header.querySelectorAll('[data-plp-tab][href^="#"]')
    );
    if (!links.length) return;

    var targets = new Map();
    links.forEach(function (link) {
      var id = decodeURIComponent(link.getAttribute('href').slice(1));
      var target = id && document.getElementById(id);
      if (target) targets.set(target, link);
    });

    function setActive(activeLink) {
      allLinks.forEach(function (link) {
        var active = link === activeLink;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    }

    // Smooth scroll on click (works even without observable targets).
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = decodeURIComponent(link.getAttribute('href').slice(1));
        var target = document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setActive(link);
      });
    });

    if (!targets.size || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActive(targets.get(entry.target));
        });
      },
      { rootMargin: '-40% 0px -55% 0px', threshold: 0 }
    );
    targets.forEach(function (link, target) {
      observer.observe(target);
    });
  }

  function init() {
    document.querySelectorAll('[data-plp-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
